<form
  class="gd-form-visible-mandatory-v2">

  <!-- Top -->
  <div
    class="gd-form-visible-mandatory-v2-top"
    fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.8rem">

    <!-- Filter -->
    <app-form-input-v2
      fxFlex
      [ngModel]="searchValue"
      name="filterValue"
      placeholder="LNG_COMMON_LABEL_SEARCH"
      autocomplete="off"
      [suffixIconButtons]="filterSuffixIconButtons"
      (ngModelChange)="filter($event, !!$event, true)"></app-form-input-v2>

    <!-- Expand All -->
    <button
      type="button"
      mat-flat-button
      color="text"
      [disabled]="!!searchValue"
      (click)="collapseExpandAll(false, true)">
      {{'LNG_COMMON_LABEL_EXPAND_ALL' | translate}}
    </button>

    <!-- Collapse All -->
    <button
      type="button"
      mat-flat-button
      color="text"
      [disabled]="!!searchValue"
      (click)="collapseExpandAll(true, true)">
      {{'LNG_COMMON_LABEL_COLLAPSE_ALL' | translate}}
    </button>

  </div>

  <!-- Records -->
  <div
    class="gd-form-visible-mandatory-v2-list">

    <!-- Records -->
    <cdk-virtual-scroll-viewport
      *ngIf="flattenedData?.length; else noSearchMatches"
      #cdkViewport
      [minBufferPx]="1024"
      [maxBufferPx]="1024"
      [itemSize]="31">
      <!-- Item -->
      <div
        *cdkVirtualFor="let item of flattenedData; templateCacheSize: 0"
        class="gd-form-visible-mandatory-v2-list-item"
        [class.gd-form-visible-mandatory-v2-list-item-group-expanded]="item.type === FlattenType.GROUP && !item.data.collapsed && !viewOnly"
        [class.gd-form-visible-mandatory-v2-list-item-group-tab-expanded]="item.type === FlattenType.GROUP_TAB && !item.data.collapsed && !viewOnly"
        [ngSwitch]="item.type">

        <!-- Group -->
        <div
          *ngSwitchCase="FlattenType.GROUP"
          class="gd-form-visible-mandatory-v2-list-item-group"
          fxLayout="row" fxLayoutAlign="none center">

          <!-- Collapse / Expand -->
          <mat-icon
            (click)="expandCollapse(item)">{{item.data.collapsed ? 'expand_more' : 'expand_less'}}</mat-icon>

          <!-- Label -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-content"
            fxFlex
            [innerHTML]="item.text | highlight:searchValue"></div>

          <!-- Counted -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-count">
            <span
              class="visible">
              {{ item.checked.visible }}
            </span>
            <span
              class="separator">
              /
            </span>
            <span
              class="mandatory">
              {{ item.checked.mandatory }}
            </span>
            <span
              class="separator">
              /
            </span>
            <span
              class="total">
              {{ item.checked.total }}
            </span>
          </div>

          <!-- Buttons -->
          <div
            *ngIf="!viewOnly"
            class="gd-form-visible-mandatory-v2-list-item-group-buttons"
            fxGrow="0">

            <!-- Check all visible -->
            <button
              type="button"
              mat-icon-button
              [matTooltip]="'LNG_COMMON_BUTTON_CHECK_ALL' | translate"
              (click)="checkUncheckAll(item, true)">
              <mat-icon>done_all</mat-icon>
            </button>

            <!-- Uncheck all visible -->
            <button
              type="button"
              mat-icon-button
              [matTooltip]="'LNG_COMMON_BUTTON_UNCHECK_ALL' | translate"
              (click)="checkUncheckAll(item, false)">
              <mat-icon>remove_done</mat-icon>
            </button>

          </div>

        </div>

        <!-- Group tab -->
        <div
          *ngSwitchCase="FlattenType.GROUP_TAB"
          class="gd-form-visible-mandatory-v2-list-item-group-tab"
          fxLayout="row" fxLayoutAlign="none center">

          <!-- Collapse / Expand -->
          <mat-icon
            (click)="expandCollapse(item)">{{item.data.collapsed ? 'expand_more' : 'expand_less'}}</mat-icon>

          <!-- Label -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-tab-content"
            fxFlex
            [innerHTML]="item.text | highlight:searchValue"></div>

          <!-- Counted -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-tab-count">
            <span
              class="visible">
              {{ item.checked.visible }}
            </span>
            <span
              class="separator">
              /
            </span>
            <span
              class="mandatory">
              {{ item.checked.mandatory }}
            </span>
            <span
              class="separator">
              /
            </span>
            <span
              class="total">
              {{ item.checked.total }}
            </span>
          </div>

          <!-- Buttons -->
          <div
            *ngIf="!viewOnly"
            class="gd-form-visible-mandatory-v2-list-item-group-tab-buttons"
            fxGrow="0">

            <!-- Check all visible -->
            <button
              type="button"
              mat-icon-button
              [matTooltip]="'LNG_COMMON_BUTTON_CHECK_ALL' | translate"
              (click)="checkUncheckAll(item, true)">
              <mat-icon>done_all</mat-icon>
            </button>

            <!-- Uncheck all visible -->
            <button
              type="button"
              mat-icon-button
              [matTooltip]="'LNG_COMMON_BUTTON_UNCHECK_ALL' | translate"
              (click)="checkUncheckAll(item, false)">
              <mat-icon>remove_done</mat-icon>
            </button>

          </div>

        </div>

        <!-- Group tab section -->
        <div
          *ngSwitchCase="FlattenType.GROUP_TAB_SECTION"
          class="gd-form-visible-mandatory-v2-list-item-group-tab-section"
          fxLayout="row" fxLayoutAlign="none center">

          <!-- Collapse / Expand -->
          <mat-icon
            (click)="expandCollapse(item)">{{item.data.collapsed ? 'expand_more' : 'expand_less'}}</mat-icon>

          <!-- Label -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-tab-section-content"
            fxFlex
            [innerHTML]="item.text | highlight:searchValue"></div>

          <!-- Counted -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-tab-section-count">
            <span
              class="visible">
              {{ item.checked.visible }}
            </span>
            <span
              class="separator">
              /
            </span>
            <span
              class="mandatory">
              {{ item.checked.mandatory }}
            </span>
            <span
              class="separator">
              /
            </span>
            <span
              class="total">
              {{ item.checked.total }}
            </span>
          </div>

          <!-- Buttons -->
          <div
            *ngIf="!viewOnly"
            class="gd-form-visible-mandatory-v2-list-item-group-tab-section-buttons"
            fxGrow="0">

            <!-- Check all visible -->
            <button
              type="button"
              mat-icon-button
              [matTooltip]="'LNG_COMMON_BUTTON_CHECK_ALL' | translate"
              (click)="checkUncheckAll(item, true)">
              <mat-icon>done_all</mat-icon>
            </button>

            <!-- Uncheck all visible -->
            <button
              type="button"
              mat-icon-button
              [matTooltip]="'LNG_COMMON_BUTTON_UNCHECK_ALL' | translate"
              (click)="checkUncheckAll(item, false)">
              <mat-icon>remove_done</mat-icon>
            </button>

          </div>

        </div>

        <!-- Group tab section field -->
        <div
          *ngSwitchCase="FlattenType.GROUP_TAB_SECTION_FIELD"
          class="gd-form-visible-mandatory-v2-list-item-group-tab-section-field"
          fxLayout="row" fxLayoutAlign="none none">

          <!-- Visible Checkbox + label -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-tab-section-field-visible"
            [class.gd-form-visible-mandatory-v2-list-item-group-tab-section-field-visible-with-needs]="!viewOnly && !!item.needs?.length"
            [class.gd-form-visible-mandatory-v2-list-item-group-tab-section-field-visible-default]="item.data.visibleMandatoryConf?.visible">
            <!-- Checkbox -->
            <app-form-checkbox-v2
              [ngModel]="item.data.visibleMandatoryConf?.visible || (value && value[item.parent.parent.parent.data.id] && value[item.parent.parent.parent.data.id][item.data.id] && value[item.parent.parent.parent.data.id][item.data.id].visible)"
              [name]="item.name.visible"
              [placeholder]="item.data.label"
              [disabled]="viewOnly || item.data.visibleMandatoryConf?.visible"
              [highlightPlaceholder]="searchValue"
              (ngModelChange)="selectedChanged(item, FieldSelectedType.VISIBLE, $event)"></app-form-checkbox-v2>

            <!-- Needs -->
            <div
              *ngIf="!viewOnly && !!item.needs?.length"
              class="gd-form-visible-mandatory-v2-list-item-group-tab-section-field-visible-needs"
              [class.gd-form-visible-mandatory-v2-list-item-group-tab-section-field-visible-needs-invalid]="errorsMap[item.parent.parent.parent.data.id] && errorsMap[item.parent.parent.parent.data.id][item.data.id]?.length"
              fxLayout="row">
              <!-- Header -->
              <div
               fxGrow="0">{{'LNG_COMMON_LABEL_NEEDS' | translate}}</div>

              <!-- Fields -->
              <div
                *ngFor="let needField of item.needs; let first = first"
                fxGrow="0">
                {{ (first ? '' : ', ') + flattenedFieldsDataMap[needField.groupId][needField.fieldId].parent.parent.parent.text + ' ' + (flattenedFieldsDataMap[needField.groupId][needField.fieldId].data.label | translate) }}
              </div>
            </div>
          </div>

          <!-- Required Checkbox -->
          <div
            class="gd-form-visible-mandatory-v2-list-item-group-tab-section-field-required"
            [class.gd-form-visible-mandatory-v2-list-item-group-tab-section-field-required-default]="item.data.visibleMandatoryConf?.required">
            <app-form-checkbox-v2
              *ngIf="item.data.supportsRequired && (item.data.visibleMandatoryConf?.required || (value && value[item.parent.parent.parent.data.id] && value[item.parent.parent.parent.data.id][item.data.id] && value[item.parent.parent.parent.data.id][item.data.id].visible))"
              [ngModel]="item.data.visibleMandatoryConf?.required || (value && value[item.parent.parent.parent.data.id] && value[item.parent.parent.parent.data.id][item.data.id] && value[item.parent.parent.parent.data.id][item.data.id].mandatory)"
              [name]="item.name.mandatory"
              placeholder="LNG_COMMON_LABEL_REQUIRED"
              [disabled]="viewOnly || item.data.visibleMandatoryConf?.required"
              (ngModelChange)="selectedChanged(item, FieldSelectedType.MANDATORY, $event)"></app-form-checkbox-v2>
          </div>

        </div>

      </div>
    </cdk-virtual-scroll-viewport>

    <!-- No matches image -->
    <ng-template
      #noSearchMatches>
      <div
        fxLayout="column" fxLayoutAlign="center center"
        class="gd-form-visible-mandatory-v2-list-empty">

        <!-- Image -->
        <div
          class="gd-form-visible-mandatory-v2-list-empty-image"></div>

        <!-- Message -->
        <div
          class="gd-form-visible-mandatory-v2-list-empty-text">{{'LNG_COMMON_LABEL_NO_SEARCH_MATCHES' | translate}}</div>
      </div>
    </ng-template>
  </div>

  <!-- Legend -->
  <div
    *ngIf="!viewOnly && !isSmallScreenMode"
    class="gd-form-visible-mandatory-v2-legend"
    fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.sm="start start">

    <!-- Header -->
    <div
      class="gd-form-visible-mandatory-v2-legend-title">
      {{'LNG_COMMON_LABEL_LEGEND' | translate}}
    </div>

    <!-- Items -->
    <div
      class="gd-form-visible-mandatory-v2-legend-items"
      fxLayout="row wrap" fxLayoutAlign="start center">

      <!-- Check all -->
      <div
        class="gd-form-visible-mandatory-v2-legend-items-item">
        <mat-icon>done_all</mat-icon>
        <span>{{'LNG_COMMON_BUTTON_CHECK_ALL' | translate}}</span>
      </div>

      <!-- Uncheck all -->
      <div
        class="gd-form-visible-mandatory-v2-legend-items-item">
        <mat-icon>remove_done</mat-icon>
        <span>{{'LNG_COMMON_BUTTON_UNCHECK_ALL' | translate}}</span>
      </div>

    </div>

  </div>

</form>
